import React from 'react'
import Navbar from '../inc/Navbar'

import { Link } from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";
import moringprayer from "../images/Morning Prayer.jpeg";



function MorningPrayer() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
          
            <div className="album py-1">
                <div className="container">
                    <h1> KRISHNAGAR PUBLIC SCHOOL </h1>
                </div>
            </div>

            <div className='cbscschoolnadia'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Morning Prayer <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <ScrollToTop smooth top="100" color="darkgoldenrod" />
            <br />
            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 className="card-title mb-3"><b>Morning Prayer</b></h1>
                        </div>
                        <div className="album py-0">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-4 mt-3">
                                        <div class="card">
                                            <img src={moringprayer} className="card-img-top" alt="moringprayer" />
                                        </div>

                                    </div>
                                    
                                    <div className="col-md-8 mt-3">
                                        <div className='welcometext'>
                                        <p className='mb-2'>Eternal God, Creator of all, we firmly believe that we are now in Your presence. </p>
                                        <p className='justify mb-2'>You are the giver of all wisdom </p>
                                        <p className='justify mb-2'>Grant us today Your Peace and Grace </p>
                                        <p className='justify mb-2'>Make us obedient children to do what is right    </p>
                                        <p className='justify mb-2'>Give us the Spirit of Excellence in all that we do </p>
<p className='justify mb-2'>Thank you for our parents, family, teachers and friends </p>
<p className='justify mb-2'>Keep us safe from all harm and danger </p>
<p className='justify mb-2'>Help us that we may never, in thought, word or deed, offend you and go against Your Holy Law </p>
                                       </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />





                    </div>
                </div>
            </div>



        </div>
    )
}

export default MorningPrayer